import React, { useEffect, useState } from 'react'
import phoneIcon from "../assets/icons/phone.png";
import emailIcon from "../assets/icons/mail.png";
import locationIcon from "../assets/icons/location.png";
import "../styles/ContactUs.css"
import userIcon from "../assets/icons/user.svg";
import worldIcon from "../assets/icons/world 1.png";
import capIcon from "../assets/icons/graduation-cap.png";

import email from "../assets/icons/email.svg"
import axios from 'axios';
import { toast } from 'sonner';

const ContactUs = (props) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [contactSettings, setContactSettings] = useState({});
    const [formData, setFormData] = useState({
        first_name: "",
        last_name: "",
        email: "",
        inquiry_for: "",
        description: "",
        student_name: "",
        dob: "",
        current_school: "",
        current_grade: "",
        // seeking_grade: "",
        parent_name: "",
        contact_number: "",
        parent_email: "",
        city: "",
    });
    const [errors, setErrors] = useState({});

    const contactInfo = [
        {
            icon: phoneIcon,
            title: "Phone Number",
            value: props.data?.school_mobile_number,
        },
        {
            icon: emailIcon,
            title: "Email ID",
            value: props.data?.school_email,
        },
        {
            icon: locationIcon,
            title: "Location",
            value: `${props.data?.address} ${props.data?.city}, ${props.data?.country}\n${props.data?.addressline}`,
        },
    ];

    const validate = () => {
        const newErrors = {};
        if(contactSettings.name){
            if (!formData.first_name.trim()) newErrors.first_name = "First Name is required";
            if (!formData.last_name.trim()) newErrors.last_name = "Last Name is required";
        }
        if (!formData.email) {
            newErrors.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = "Invalid email address";
        }
        if (!formData.inquiry_for) newErrors.inquiry_for = "Please select an option";
        if(contactSettings.description){
            if (!formData.description.trim()) newErrors.description = "Description is required";
        }
        // Admission extra validation
        if (formData.inquiry_for === "Admission") {
            // Check if student name is provided
            if (!formData.student_name.trim())
                newErrors.student_name = "Student full name is required";

            // Check if date of birth is provided
            if (!formData.dob) {
                newErrors.dob = "Date of Birth is required";
            } else {
                // Additional validation for "at least 3 years old"
                const currentDate = new Date();
                const dobDate = new Date(formData.dob);
                const age = currentDate.getFullYear() - dobDate.getFullYear();
                const m = currentDate.getMonth() - dobDate.getMonth();

                if (age < 3 || (age === 3 && m < 0)) {
                    newErrors.dob = "Student must be at least 3 years old.";
                }
            }

            // Check if current school is provided
            if (!formData.current_school.trim())
                newErrors.current_school = "Current school is required";

            // Check if current grade is provided
            if (!formData.current_grade)
                newErrors.current_grade = "Current grade is required";

            // Check if parent name is provided
            if (!formData.parent_name.trim())
                newErrors.parent_name = "Parent/Guardian name is required";

            // Check if contact number is provided
            if (!formData.contact_number.trim())
                newErrors.contact_number = "Contact number is required";

            // Check if parent email is provided
            if (!formData.parent_email)
                newErrors.parent_email = "Parent email is required";

            // Check if city is provided
            if (!formData.city.trim())
                newErrors.city = "City is required";
        }
        return newErrors;
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setErrors({});
        setIsSubmitting(true);

        const windowUrl = window.location.href;
        const hostname = new URL(windowUrl).hostname;
        const parts = hostname.split(".");
        const subDomain = parts.length > 1 ? parts[0] : null;

        if (!subDomain) {
            window.location.href = process.env.REACT_APP_MARKETING_URL;
            return;
        }

        try {
            console.log('formData:::::::::::::::::::::::: ', formData);
            const response = await axios.post(`${process.env.REACT_APP_URL}/front/contact-us/${subDomain}`, formData);

            if (response.status === 200) {
                toast.success("Your inquiry has been submitted successfully. We will get back to you shortly!");
            } else {
                toast.error(response.data.message || "Something went wrong. Please try again later.");
            }

        } catch (error) {
            console.error("Error during form submission:", error);
            toast.error(error.response?.data?.message || "An unexpected error occurred. Please try again.");
        } finally {
            setIsSubmitting(false);
            setFormData({
                first_name: "",
                last_name: "",
                email: "",
                inquiry_for: "",
                description: "",
                student_name: "",
                dob: "",
                current_school: "",
                current_grade: "",
                // seeking_grade: "",
                parent_name: "",
                contact_number: "",
                parent_email: "",
                city: "",
            });
        }
    };

    // const handleSubmit = async (e) => {
    //     e.preventDefault();

    //     if (!email) {
    //       toast.warning('Please Enter Email ID.');
    //       return;
    //     }

    //     setIsSubmitting(true); 

    //     const windowUrl = window.location.href;
    //     const hostname = new URL(windowUrl).hostname; // "jay.localhost"
    //     const parts = hostname.split(".");
    //     const subDomain = parts.length > 1 ? parts[0] : null;
    //     if (!subDomain) {
    //       window.location.href = process.env.REACT_APP_MARKETING_URL;
    //     }

    //     try {
    //       const response = await axios.post(`${process.env.REACT_APP_URL}/front/newsletter/${subDomain}`, {
    //         email,
    //       });

    //       console.log('response::::::::::::::::::::::::: ', response);
    //       if (response) {
    //         toast.success('You have successfully subscribed!');
    //       } else {
    //         toast.error(response.data.message);
    //       }
    //     } catch (error) {
    //       console.error("Error during subscription:", error);
    //       toast.error(error.response.data.message);
    //     } finally {
    //       setIsSubmitting(false);
    //       setEmail("");
    //     }
    //   };

    const fetchContactSettings = async (subDomain) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_URL}/front/contact-settings/${subDomain}`);
            if (response.status === 200) {
                console.log('Contact Settings Response:', response.data.data);
                setContactSettings(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching contact settings:", error);
            toast.error(error.response?.data?.message || "An unexpected error occurred.");
        }
    };

    useEffect(() => {
        const windowUrl = window.location.href;
        const hostname = new URL(windowUrl).hostname; // "jay.localhost"
        const parts = hostname.split(".");
        const subDomain = parts.length > 1 ? parts[0] : null;
        if (subDomain) {
            fetchContactSettings(subDomain);
        }
    }, []);

    return (
        <div className='py-16 bg-white'>
            <div>
                <h2 className="text-f100 text-primary_main text-center font-extrabold mb-12">
                    Contact Us
                </h2>
            </div>

            <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-3 md:max-w-lg lg:max-w-3xl xl:max-w-[60rem] 2xl:max-w-6xl px-4   sm:mx-auto mb-12 gap-4">
                {contactInfo.map((item, i) => (
                    <div
                        key={i}
                        className="bg-[#F9F5FF] rounded-2xl p-6  flex text-left items-start gap-4 w-full" // Full width on mobile and small screens
                    >
                        <img src={item.icon} alt={item.title} className="w-10 h-10" />
                        <div>
                            <h4 className="text-lg">{item.title}</h4>
                            <p className="text-sm text-gray-600 whitespace-pre-line">
                                {item.value}
                            </p>
                        </div>
                    </div>
                ))}
            </div>

            {/* Form Section */}
            <div className=" w-full md:max-w-lg lg:max-w-3xl xl:max-w-[60rem] 2xl:max-w-6xl px-4 mx-auto text-left flex flex-col lg:flex-row justify-center gap-8">
                {/* Left Side Text */}
                <div className="flex items-center justify-center w-full lg:w-[50%] font-extrabold">
                    <h3 className="text-xl sm:text-xl md:text-2xl lg:text-4xl leading-snug text-center lg:text-left">
                        We are Always <br />
                        Ready <span className="text-primary_main">to Hear</span> <br />
                        <span className="text-primary_main">From You</span>
                    </h3>
                </div>


                {/* Right Side Form */}
                <form autoComplete='off' onSubmit={handleSubmit} className='w-full'>
                    <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-3'>

                        {contactSettings.name && (
                            <div>
                                <label>First Name<span className="required">*</span></label>
                                <div className="input-group font-medium">
                                    <span className="icon">
                                        <img src={userIcon} alt="user icon" />
                                    </span>
                                    <input
                                        type="text"
                                        autoComplete='new-first_name'
                                        name='first_name'
                                        value={formData.first_name}
                                        onChange={handleChange}
                                        placeholder="Enter First Name"
                                        maxLength={30}
                                    />
                                </div>
                                {errors.first_name && <p className="text-red-500 text-xs mt-1">{errors.first_name}</p>}
                            </div>
                        )}
                        {contactSettings.name && (
                            <div>
                                <label>Last Name<span className="required">*</span></label>
                                <div className="input-group">
                                    <span className="icon">
                                        <img src={userIcon} alt="user icon" />
                                    </span>
                                    <input
                                        type="text"
                                        autoComplete='new-last_name'
                                        name='last_name'
                                        value={formData.last_name}
                                        onChange={handleChange}
                                        placeholder="Enter Last Name"
                                        maxLength={30}
                                    />
                                </div>
                                {errors.last_name && <p className="text-red-500 text-xs mt-1">{errors.last_name}</p>}
                            </div>
                        )}
                        <div>
                            <label>Email ID<span className="required">*</span></label>
                            <div className="input-group">
                                <span className="icon">
                                    <img src={email} alt="email icon" />
                                </span>
                                <input
                                    type="email"
                                    autoComplete='new-email'
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    placeholder="Enter Your Email ID"
                                />
                            </div>
                            {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email}</p>}
                        </div>

                        <div>
                            <label>Inquiry For<span className="required">*</span></label>
                            <div className="input-group">
                                <select name="inquiry_for" value={formData.inquiry_for} onChange={handleChange}>
                                    <option value={""}>Select</option>
                                    <option value={"Admission"}>Admission</option>
                                    <option value={"Queries"}>Queries</option>
                                    <option value={"Feedback"}>Feedback</option>
                                    <option value={"Careers"}>Careers</option>
                                </select>
                            </div>
                            {errors.inquiry_for && <p className="text-red-500 text-xs mt-1">{errors.inquiry_for}</p>}
                        </div>
                    </div>


                    <div>
                        {contactSettings.description && (
                            <div>
                                <label>Description<span className="required">*</span></label>
                                <div className="input-group font-medium">
                                    <textarea
                                        name='description'
                                        value={formData.description}
                                        onChange={handleChange}
                                        placeholder="Enter Description"
                                        maxLength={500}
                                    />
                                </div>
                                {errors.description && <p className="text-red-500 text-xs mt-1">{errors.description}</p>}
                            </div>
                        )}
                        {/* Conditional Fields for Admission */}
                        {formData.inquiry_for === "Admission" && (
                            <div className="mt-6 border-t pt-4">
                                <h4 className="font-bold mb-3">*Please Fill the Below Details</h4>
                                <h4 className="font-bold mb-3">Basic Student Information</h4>

                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                    <div>
                                        <label>Student’s Full Name<span className="required">*</span></label>
                                        <div className='input-group'>
                                            <span className="icon">
                                                <img src={userIcon} alt="user icon" />
                                            </span>
                                            <input
                                                type="text"
                                                name="student_name"
                                                value={formData.student_name}
                                                onChange={handleChange}
                                                placeholder="Enter Full Name"
                                                maxLength={50}
                                            />
                                        </div>
                                        {errors.student_name && <p className="text-red-500 text-xs">{errors.student_name}</p>}
                                    </div>
                                    <div>
                                        <label>Date of Birth<span className="required">*</span></label>
                                        <div className='input-group'>
                                            <input
                                                type="date"
                                                name="dob"
                                                value={formData.dob}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        {errors.dob && <p className="text-red-500 text-xs">{errors.dob}</p>}
                                    </div>
                                </div>
                                <h4 className="font-bold mb-3">Academic Details</h4>

                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-3">
                                    <div>
                                        <label>Current / Last Attended School<span className="required">*</span></label>
                                        <div className='input-group'>
                                            <span className="icon">
                                                <img src={capIcon} alt="user icon" />
                                            </span>
                                            <input
                                                type="text"
                                                name="current_school"
                                                value={formData.current_school}
                                                onChange={handleChange}
                                                placeholder="Enter School Name"
                                                maxLength={100}
                                            />
                                        </div>
                                        {errors.current_school && <p className="text-red-500 text-xs">{errors.current_school}</p>}
                                    </div>
                                    <div>
                                        <label>Current Grade / Class<span className="required">*</span></label>
                                        <div className='input-group'>
                                            <input
                                                type="text"
                                                name="current_grade"
                                                value={formData.current_grade}
                                                onChange={handleChange}
                                                placeholder="Enter Grade/Class"
                                                maxLength={30}
                                            />
                                        </div>
                                        {errors.current_grade && <p className="text-red-500 text-xs">{errors.current_grade}</p>}
                                    </div>
                                </div>

                                <h4 className="font-bold mb-1 mt-3">Parent / Guardian Information</h4>

                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                    <div>
                                        <label>Parent/Guardian Full Name<span className="required">*</span></label>
                                        <div className='input-group'>
                                            <span className="icon">
                                                <img src={userIcon} alt="user icon" />
                                            </span>
                                            <input
                                                type="text"
                                                name="parent_name"
                                                value={formData.parent_name}
                                                onChange={handleChange}
                                                placeholder="Enter Parent/Guardian Name"
                                                maxLength={50}
                                            />
                                        </div>
                                        {errors.parent_name && <p className="text-red-500 text-xs">{errors.parent_name}</p>}
                                    </div>
                                    
                                    <div>
                                        <label>Contact Number<span className="required">*</span> (WhatsApp Preferred)</label>
                                        <div className='input-group'>
                                            <span className="icon">
                                                <img src={worldIcon} alt="user icon" />
                                            </span>
                                            <input
                                                type="text"
                                                name="contact_number"
                                                value={formData.contact_number}
                                                onChange={handleChange}
                                                onKeyPress={(e) => {
                                                    if (!/[\d]/.test(e.key)) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                placeholder="Enter Contact Number"
                                                maxLength={10}
                                                pattern="\d*"
                                                required
                                            />
                                        </div>
                                        {errors.contact_number && <p className="text-red-500 text-xs">{errors.contact_number}</p>}
                                    </div>
                                    
                                </div>

                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-3">
                                    <div>
                                        <label>Email ID<span className="required">*</span></label>
                                        <div className="input-group">
                                            <span className="icon">
                                                <img src={email} alt="email icon" />
                                            </span>
                                            <input
                                                type="email"
                                                name="parent_email"
                                                value={formData.parent_email}
                                                onChange={handleChange}
                                                placeholder="Enter Parent Email"
                                            />
                                        </div>
                                        {errors.parent_email && <p className="text-red-500 text-xs">{errors.parent_email}</p>}
                                    </div>
                                    <div>
                                        <label>City / Location<span className="required">*</span></label>
                                        <div className='input-group'>
                                            <input
                                                type="text"
                                                name="city"
                                                value={formData.city}
                                                onChange={handleChange}
                                                placeholder="Enter City"
                                                maxLength={50}
                                            />
                                        </div>
                                        {errors.city && <p className="text-red-500 text-xs">{errors.city}</p>}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="w-full flex justify-center gap-3 mb-2 mt-4">
                        <button
                            type="submit"
                            className="button-field-secondary flex justify-center"
                        // style={{ width: "30%" }}
                        >
                            {isSubmitting ? "Please wait..." : "Submit"}
                        </button>
                    </div>
                </form>
            </div>
        </div>

    )
}

export default ContactUs